import isString from 'lodash/isString';
import { TableColumn, UserTableModel } from 'modules/Users/DataTableDef';

type Props = {
  user: UserTableModel;
  def: TableColumn<UserTableModel>;
};

const DataTableRowItem = ({ user, def }: Props) => {
  let value = user[def.name] as any;

  if (def.render) {
    value = def.render(value, user);
  }

  const title = isString(value) ? value : '';

  return (
    <td title={title} style={def.style}>
      {value}
    </td>
  );
};

export default DataTableRowItem;
